// Generování GUID (RFC 4122 v4). BCF používá GUID jako primární identifikátory
// témat, komentářů i viewpointů. Importované GUID se NIKDY neregenerují (§4).
export function guid() {
  if (typeof crypto !== "undefined" && crypto.randomUUID) return crypto.randomUUID();
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

// Validace tvaru GUID — neprázdný řetězec bez bílých znaků (BCF povoluje i GUID
// bez pomlček / IFC komprimované GUID, proto nekontrolujeme přesný formát).
export function isValidGuid(g) {
  return typeof g === "string" && g.length > 0 && !/\s/.test(g);
}
